// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".quote-header.fixed-grid[data-v-34979168],\n.quote-header.fixed-grid > .grid[data-v-34979168] {\n  height: 100%;\n}", ""]);
// Exports
module.exports = exports;
